import styled, { keyframes } from 'styled-components';
import { vars } from 'utils/variables';
import { getRandomPastelColor } from 'services/getRandomPastelColor';

const openInput = keyframes`
  0% {
    width:  45px;
  }
  100% {
    width:  195px;
  }
`;

const openList = numberOfItems => keyframes`
  0%{
   height: 0;
   padding-top: 0;
   padding-bottom: 0;
  }
  100%{
     height: calc(18px + ${numberOfItems} * 25px + (${numberOfItems} - 1) * 4px);
     padding-top: 8px;
     padding-bottom: 8px;

  }
`;

const closeList = numberOfItems => keyframes`
 0%{
  height: calc(18px + ${numberOfItems} * 25px + (${numberOfItems} - 1) * 4px);
  padding-top: 8px;
  padding-bottom: 8px;

  }
  100%{
   height: 0;
   padding-top: 0;
   padding-bottom: 0;

  }
`;

const orientation = { left: 'flex-start', center: 'center' };
const listStatus = { open: vars.dark30, close: vars.dark5 };
const accountIconSize = {
  menu: '30px',
  'user-cabinet': '40px',
};

export const UserMenuHeadWrap = styled.section`
  width: 100%;

  padding: 16px 24px;
  padding-bottom: ${props =>
    props.$pageType === 'user-cabinet' ? '0px' : '16px'};

  background-color: ${props =>
    props.$pageType === 'user-cabinet' ? 'transparent' : vars.light50};
`;

export const UserDataWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: ${props => orientation[props.$orientation]};
  gap: 8px;
`;

export const UserIconWrap = styled.button`
  width: 58px;
  height: 32px;

  display: flex;
  align-items: center;

  background-color: transparent;

  border: 1px solid;
  border-color: ${props => listStatus[props.$isListOpen]};
  border-radius: 30px;

  transition: border-color ${vars.transitionTimingFunction};

  &:hover,
  &:focus-visible {
    border-color: ${vars.dark30};
  }
`;

export const UserIcon = styled.svg`
  width: ${props => accountIconSize[props.$pageType]};
  height: ${props => accountIconSize[props.$pageType]};

  fill: ${vars.dark70};
`;

export const ArrowIcon = styled.svg`
  width: 18px;
  height: 18px;
  margin-left: 4px;

  fill: ${vars.dark70};

  transform: rotateZ(-90deg);
`;

export const UserNameWrap = styled.section`
  display: flex;
  align-items: center;
  gap: 5px;

  & > h5 {
    min-height: 27px;
    color: ${vars.dark70};
  }
`;

export const UserMeta = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  color: ${vars.darkBlack100};
`;

export const UserNameInput = styled.input`
  min-width: 20px;
  width: 195px;
  min-height: 24px;

  padding: 1px 0;

  display: inline-flex;
  align-items: center;

  background-color: transparent;
  outline: none;
  border: 1px solid ${vars.secondaryLightBlue};

  animation: 400ms ${openInput} ease-in-out;

  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
`;

export const EditIcon = styled.svg`
  width: ${props => (props.$type === 'pencil' ? '12px' : '14px')};
  height: ${props => (props.$type === 'pencil' ? '12px' : '14px')};
  fill: ${vars.dark70};
  cursor: pointer;

  transition: fill ${vars.transitionTimingFunction};

  &:hover,
  &:focus-visible {
    fill: ${props =>
      props.$type === 'pencil' ? vars.secondaryBlue : vars.secondaryGreenDark};
  }
`;

export const UserMail = styled.p`
  font-size: 11px;
  font-weight: 400;
  line-height: normal;
`;

//--------------Accounts-------------------

export const AccountList = styled.ul`
  max-width: 300px;
  width: 100%;
  max-height: 110px;

  padding: 8px;
  margin-top: 8px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2px;

  background-color: transparent;

  border-radius: 12px;
  border: 1px solid ${vars.dark5};
  box-shadow: ${vars.boxShadow};

  overflow-x: hidden;

  animation: ${props =>
      props.$isListOpen === 'open'
        ? openList(props.$numberOfItems)
        : closeList(props.$numberOfItems)}
    0.5s ease-in-out;

  &::-webkit-scrollbar {
    width: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    margin: 8px 0;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${vars.darkTransparent5};
    border-radius: 10px;
    cursor: pointer;
  }
`;

export const AccountItem = styled.button`
  width: 100%;
  height: 25px;

  padding-left: 4px;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  background-color: transparent;
  color: ${vars.dark70};

  border-radius: 12px;
  box-shadow: ${vars.boxShadow};

  font-size: 11px;
  font-weight: 500;
  line-height: 10px;
  text-transform: capitalize;

  transition: background-color ${vars.transitionTimingFunction};

  &:hover,
  &:active {
    background-color: ${vars.light100};
  }

  & > p > span {
    text-transform: lowercase;
  }
`;

export const AccountMark = styled.div`
  width: 20px;
  height: 20px;

  margin-right: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${() => getRandomPastelColor()};

  border-radius: 50%;
`;

export const AccountFirstLetter = styled.span`
  color: ${vars.light100};
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
`;
